import {time, translateTime} from './time';
import {currency} from './currency';

export default {
	time,
	translateTime,
	currency
};



// WEBPACK FOOTER //
// ./src/filters/index.js